import React from 'react'

import Section from '../Section'
import Container from '../Container'
import Address from '../Address'

type AddressesProps = {
  title: string
  type: 'mailOrder' | 'licensees'
  addresses: any[]
}

const Addresses = ({ title, type, addresses }: AddressesProps) => {
  return (
    <Section className="addresses">
      <Container>
        <h2>{title}</h2>
        {addresses.map((address: any, index: number) => {
          return <Address key={`${type}-${index}`} address={address} />
        })}
      </Container>
    </Section>
  )
}

export default React.memo(Addresses)
